module.exports = __webpack_public_path__ + "static/media/Pioneer_img.77eb2ef6.png";